module.exports = __webpack_public_path__ + "static/media/email.ddb6a7fd.svg";